export default [
  {
    path: '/search-invoice-management',
    name: 'search-invoice-management',
    component: () =>
      import('@/views/modules/search-invoice-management/SearchInvoice.vue'),
  },
]
